import * as React from 'react';
import { FieldProps, FastField } from 'formik';

interface ICheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  secondary?: boolean;
}

export const Checkbox = ({
  secondary,
  name,
  children,
  id,
  className = '',
  type = 'checkbox',
  ...props
}: ICheckboxProps) => (
  <div
    className={`checkbox ${secondary ? 'checkbox-secondary' : ''} ${className}`}
  >
    <input type={type} name={name} id={id || name} {...props} />
    <label
      htmlFor={id || name}
      className={`select-none ${
        props.disabled ? 'opacity-50 pointer-events-none' : ''
      }`}
    >
      {children}
    </label>
  </div>
);

const renderFormCheckbox = (props: ICheckboxProps) => ({
  field: { value, ...rest },
}: FieldProps<any>) => {
  const checked =
    props.type === 'radio' ? Number(value) === props.value : value;
  return <Checkbox checked={checked} {...rest} {...props} />;
};

export const FormCheckbox = ({ name, ...props }: ICheckboxProps) => (
  <FastField name={name} render={renderFormCheckbox(props)} />
);



// WEBPACK FOOTER //
// ./src/components/Form/Checkbox.tsx